<template>
  <div class="Warning">
    <div class="WarningWidth">
      <Warning ref="Warning" :WarningData="WarningData"></Warning>
    </div>
  </div>
</template>

<script>

import Warning from "./warningCenterComponents/warning/warning.vue"
export default {
  components: {
    Warning,
    
  },
  props: {
    WarningData: {
      type: Array
    }
  },
  data() {
    return {

    }
  },
  watch: {

  },
  mounted() {

  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.Warning {
  height: 480px;
  min-width: 1200px;
  position: relative;
  .WarningWidth {
    width: 101%;
    height: 100%;
    // border: 1px solid #bbb;
  }
}
</style>